function initializeLoadMore() {
  const loadMoreButton = document.querySelector('#LoadMoreButton');
  const productGrid = document.querySelector('#product-grid');

  if (!loadMoreButton || !productGrid || loadMoreButton.dataset.initialized === 'true') return;

  loadMoreButton.dataset.initialized = 'true';

  let isLoading = false;

  loadMoreButton.addEventListener('click', async function () {
    if (isLoading) return;

    const nextUrl = loadMoreButton.dataset.nextUrl;
    if (!nextUrl) return;

    isLoading = true;
    loadMoreButton.classList.add('loading');
    loadMoreButton.textContent = 'Loading...';

    try {
      const response = await fetch(nextUrl, {
        method: 'GET',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error('Failed to load more products.');
      }

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newGrid = doc.querySelector('#product-grid');
      const newButton = doc.querySelector('#LoadMoreButton');

      if (!newGrid) {
        throw new Error('Product grid not found in response.');
      }

      const newItems = newGrid.querySelectorAll('li.grid__item');

      newItems.forEach((item) => {
        productGrid.appendChild(item);
      });

      if (newButton && newButton.dataset.nextUrl) {
        loadMoreButton.dataset.nextUrl = newButton.dataset.nextUrl;
        loadMoreButton.textContent = 'Load More';
      } else {
        loadMoreButton.remove();
      }
    } catch (error) {
      console.error(error);
      loadMoreButton.textContent = 'Load More';
    } finally {
      isLoading = false;
      loadMoreButton.classList.remove('loading');
    }
  });
}

document.addEventListener('DOMContentLoaded', initializeLoadMore);
document.addEventListener('shopify:section:load', initializeLoadMore);

const observer = new MutationObserver(() => {
  initializeLoadMore();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});